import {Box, CircularProgress, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import PropTypes from "prop-types";
import {useRayzayUIController} from "../../context";

const LoadingContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'hasSidenav'
})(({theme, hasSidenav}) => ({
    position: 'fixed',
    top: 0,
    left: hasSidenav ? {
        [theme.breakpoints.up('xl')]: '280px', // Sidenav width when expanded
        [theme.breakpoints.down('xl')]: '80px', // Sidenav width when collapsed
        [theme.breakpoints.down('lg')]: 0, // Full width on mobile
    } : 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(8px)',
    zIndex: 9999,
}));

const LoadingSpinner = ({message = "Loading...", size = 40, showSidenav = true}) => {
    const [controller] = useRayzayUIController();
    const {layout} = controller;

    // Only show sidenav offset if we're in dashboard layout
    const hasSidenav = showSidenav && layout === "dashboard";

    return (
        <LoadingContainer hasSidenav={hasSidenav}>
            <CircularProgress
                size={size}
                thickness={4}
                sx={{
                    color: (theme) => theme.palette.primary.main,
                    marginBottom: 2,
                    animation: 'pulse 2s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%': {
                            opacity: 1,
                        },
                        '50%': {
                            opacity: 0.7,
                        },
                        '100%': {
                            opacity: 1,
                        },
                    },
                }}
            />
            <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                    fontWeight: 500,
                    textAlign: 'center',
                    maxWidth: '300px',
                    lineHeight: 1.4
                }}
            >
                {message}
            </Typography>
        </LoadingContainer>
    );
};

LoadingSpinner.propTypes = {
    message: PropTypes.string,
    size: PropTypes.number,
    showSidenav: PropTypes.bool
};

export default LoadingSpinner;
